export const columns = [
  { accessorKey: "serialNo", header: "Serial #", flex: 1 },

  { accessorKey: "rfidTagNumber", header: "RFID Tag Number", flex: 1 },
  { accessorKey: "vehicleNumber", header: "Vehicle", flex: 1 },

  {
    accessorKey: "actionButtons",
    header: "Actions",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
